<template>
  <b-media tag="li">
    <template #aside>
      <div class="img-box">
        <b-img
          :src="itemData.imageLink || itemData.custom.shopImage"
          width="50"
          height="50"
          alt="placeholder"
        ></b-img>
      </div>
    </template>
    <div class="orderItmeDetailsSec">
      <div class="item-qty">
        <h6 class="mt-0 mb-3 text-left">
          {{ itemData.name || itemData.providerName }}
        </h6>
      </div>

      <div class="price-details">
        <div class="d-flex deal-price align-items-center mb-2">
          <h6 class="">
            {{ currency.symbol }} {{ itemData.price.toFixed(2) }}
          </h6>
          <del v-if="itemData.unitDiscountedPrice" class="text-icon mb-0 ml-3">
            {{ currency.symbol }}
            {{ (itemData.unitPrice * itemData.qty).toFixed(2) }}
          </del>
        </div>
        <div>
          <h6 class="discount-rate" v-if="itemData.discount > 0">
            {{ currency.symbol }}
            {{ (itemData.discount * itemData.qty).toFixed(2) }} Off
          </h6>
          <!-- <h6 class="discount-rate pl-3" v-else-if="itemData.discount > 0">
            {{ itemData.discount }}% Off
          </h6> -->
        </div>
      </div>
      <p class="text-top">Quantity: {{ itemData.qty }}</p>
      <p class="text-icon mb-0 itemPricePara">
        {{ currency.symbol }} {{ itemData.price.toFixed(2) }}
      </p>
    </div>
  </b-media>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "order-details-item",
  props: {
    itemData: {
      default: () => {},
      type: Object,
    },
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.auth.userInfo,
      currency: (state) => state.home.currency,
    }),
  },
};
</script>

<style scoped>
.orderItmeDetailsSec {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.img-box {
  border: 1px solid #efefef;
  border-radius: 5px;
  padding: 4px;
}
.deal-price h6 {
  margin-bottom: 0px;
  color: #3a38c5;
}
.deal-price del {
  color: #949494;
}
.discount-rate {
  margin-top: 0px;
  color: #ff7a7a;
}
.item-qty span {
  color: #aaaaaa;
}
h6,
p {
  margin: 0px;
}
.item-qty {
  margin-left: 1rem;
}
.itemPricePara {
  margin-left: 1rem;
}
@media (max-width: 768px) {
  .orderItmeDetailsSec {
    display: block;
  }
  .orderItmeDetailsSec .item-qty {
    margin-left: 0px;
  }
  .itemPricePara {
    margin-left: 0;
    margin-top: 8px;
  }
}
</style>
